import React from 'react';

function withoutEnterSubmit<T>(Form: React.ComponentType<T>) {
  function handleKeyPress(e: React.KeyboardEvent) {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }

  return React.memo((props: T) => <Form onKeyPress={handleKeyPress} {...props} />);
}

export default withoutEnterSubmit;
